import api from '@/services/api'

export default {
  namespaced: true,
  state() {
    return {
      loading: false,
      error: null,
    }
  },
  mutations: {
    SET_LOADING( state, status ) {
      state.loading = status
    },
    SET_ERROR( state, error ) {
      state.error = error
    },
  },
  actions: {
    async cancelReservation( { commit }, payload ) {
      commit( 'SET_LOADING', true )
      commit( 'SET_ERROR', null )

      try {
        const response = await api.cancelReservation( payload )
        return response.data
      } catch( error ) {
        commit( 'SET_ERROR', error )
        throw error
      } finally {
        commit( 'SET_LOADING', false )
      }
    }
  }
}